import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickAddIdColumn from '@/components/brick_add_id_column.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-circle', 'text-orange']
infos.front_classes = ['fas', 'fa-id-card', 'text-white']
infos.name = 'addid'
infos.associated_class_name = 'AutomlAddIdColumn'
infos.editing_component_name = 'BrickAddIdColumn'
infos.editing_component = BrickAddIdColumn
infos.descriptions = {
	en: {
		short_tooltip_description: 'ID column',
		full_tooltip_description: 'Adds a unique ID column',
		navbar_name: 'ID column',
	},
	fr: {
		short_tooltip_description: 'Colonne unique',
		full_tooltip_description: 'Ajoute une colonne unique (i.e. ID)',
		navbar_name: 'Colonne unique',
	},
}
// infos.short_tooltip_description = 'addid_short_tooltip'
// infos.full_tooltip_description = 'addid_full_tooltip'
// infos.navbar_name = 'addid_navbar'
infos.background_color = 'orange'

brick_registerer(infos)
